module.exports = __webpack_public_path__ + "img/info_7.37bbe5a0.jpeg";